var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSymbolRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Applystart A Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #ff5a60 } \r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m230.3 99.4l-53.3 118.8-24.3 53.3-52.5 114-41.2-90.5c-8.1-13-24.3-16.2-37.2-8.9-10.5 6.5-15.4 19.4-11.3 31.5l66.2 143.9c4.1 9.7 13.8 15.4 24.3 15.4 10.5 0 20.2-6.5 24.2-15.4l67.1-147.9 19.4-42.9 24.3-53.3 30.7-66.3-29.9-65.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m487.4 439.7l-181.1-401c-6.5-12.9-22.6-19.4-35.6-12.9-5.6 2.4-10.5 7.3-12.9 12.9l-4.8 11.4 29.9 64.6 139 307.2-32.3 0.8-20.2-45.3-65.5-144.7c0-0.8-0.8-0.8-0.8-0.8l-7.3-14.5-19.4 43.6-0.8 1.6-9.7 19.4 80.8 178.7c4.1 9.7 13.8 16.2 24.3 16.2h92.1c8.9 0 17.8-4.9 22.7-13 4.8-6.4 5.6-16.1 1.6-24.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbolRed);
export default __webpack_public_path__ + "static/media/logo-symbol-red.3c1531c2d88abfdc55a16bc0ca86f60f.svg";
export { ForwardRef as ReactComponent };